import { type AlignmentAttempt, AlignmentStage, ServiceWorkerAlignment } from './types';

export function isServiceWorkerAlignmentFailed(alignment: ServiceWorkerAlignment): boolean {
  return alignment === ServiceWorkerAlignment.failed;
}

/** A take-over waited for less than this proves nothing: the installation may have used the time up. */
export const MIN_TAKE_OVER_WAIT_MS = 5_000;

/**
 * A newer worker was told to take over and was waited for, long enough, without becoming active. The
 * activation takes no time, so this is a stuck worker, not a slow deploy: trying again changes nothing.
 * A worker that became redundant was replaced by a newer deploy, and one waited for too briefly says nothing.
 */
export function isTakeOverStuck(attempt: AlignmentAttempt): boolean {
  const { failure } = attempt;
  return (
    failure?.stage === AlignmentStage.takingOver &&
    failure.takeOver !== undefined &&
    failure.takeOver.workerState !== 'redundant' &&
    failure.takeOver.waitedMs >= MIN_TAKE_OVER_WAIT_MS
  );
}

/** The stage each failed attempt stood at, in order. */
export function getFailedStages(attempts: AlignmentAttempt[]): AlignmentStage[] {
  return attempts.flatMap(({ failure }) => (failure ? [failure.stage] : []));
}
